'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { OutageBanner, OutageBannerSite } from '@sola/sdg-sdk/lib/outage-banner/schema.ts';
import { fetchActiveOutageBanners } from '@sola/sdg-sdk/utils/routes.ts';
import { OutageRibbon } from './outage-ribbon.tsx';
type OutageBannerClientProps = {
  site: OutageBannerSite;
};
export const OutageBannerClient: React.FC<OutageBannerClientProps> = t0 => {
  const $ = _c(5);
  const {
    site
  } = t0;
  const [banner, setBanner] = useState();
  let t1;
  let t2;
  if ($[0] !== site) {
    t1 = () => {
      fetchActiveOutageBanners(site).then(bannerData => setBanner(bannerData?.items?.[0] ?? undefined));
    };
    t2 = [site];
    $[0] = site;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!banner) {
    return;
  }
  let t3;
  if ($[3] !== banner) {
    t3 = <OutageRibbon {...banner} />;
    $[3] = banner;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};